// removed by extract-text-webpack-plugin
module.exports = {"App":"_1o-FpbQrR11SDFN-G7O4U3"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 968
// module chunks = 0